import React, { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { AlertTriangle, X } from 'lucide-react';
import { PaymentOptions } from '@/components/PaymentOptions';

export const SubscriptionBanner = () => {
  const { user } = useAuth();
  const [showPayment, setShowPayment] = useState(false);

  if (!user || user.role === 'admin' || !user.subscription_expires_at) return null;

  const expiresAt = new Date(user.subscription_expires_at);
  const now = new Date();
  const daysLeft = Math.ceil((expiresAt - now) / (1000 * 60 * 60 * 24));

  if (daysLeft > 5 || daysLeft <= 0) return null;

  return (
    <>
      <div className="fixed top-20 left-1/2 -translate-x-1/2 z-50" data-testid="subscription-banner">
        <div className="bg-orange-500/20 border border-orange-500/50 rounded-lg px-6 py-3 flex items-center space-x-3 backdrop-blur-sm animate-pulse">
          <AlertTriangle className="h-5 w-5 text-orange-400 flex-shrink-0" />
          <p className="text-orange-200 text-sm font-medium">
            Tu suscripción vence en <span className="text-orange-400 font-bold">{daysLeft} día{daysLeft !== 1 ? 's' : ''}</span>.
          </p>
          <button
            onClick={() => setShowPayment(true)}
            className="ml-2 bg-orange-500 text-black text-xs font-bold px-3 py-1 rounded hover:bg-orange-400 transition-colors whitespace-nowrap"
            data-testid="subscription-renew-btn"
          >
            Renovar
          </button>
        </div>
      </div>

      {showPayment && (
        <div className="fixed inset-0 z-[80] bg-black/90 flex items-center justify-center p-4 overflow-y-auto" data-testid="renewal-modal">
          <button
            onClick={() => setShowPayment(false)}
            className="absolute top-4 right-4 text-white/60 hover:text-white z-10"
            data-testid="renewal-modal-close"
          >
            <X className="h-6 w-6" />
          </button>
          <PaymentOptions
            title="RENOVAR SUSCRIPCIÓN"
            subtitle={`Tu suscripción vence en ${daysLeft} día${daysLeft !== 1 ? 's' : ''}. Renueva ahora para no perder acceso.`}
            userName={user.name || ''}
            userEmail={user.email || ''}
            onBack={() => setShowPayment(false)}
            mode="renewal"
          />
        </div>
      )}
    </>
  );
};
